module.exports = __webpack_public_path__ + "img/BE0450507887.7a5cb292.png";